const ORDER_MESSAGE_EXTRA_NOTES_VHOSTS = new Set(["chomar.pl", "planeta"])

export const shouldShowOrderMessageExtraNotes = (
  vhost: string | undefined,
): boolean => ORDER_MESSAGE_EXTRA_NOTES_VHOSTS.has(vhost ?? "")
